module.exports = __webpack_public_path__ + "static/media/buy_report_service_6.ba836f85.png";